import * as Sentry from '@sentry/react';
import React from 'react';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  integrations: [
    Sentry.browserProfilingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  // Error + performance tracking
  tracesSampleRate: 1.0, // 100% transaction cho performance
  profilesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.2, // 20% transaction có profile CPU stack trace

  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  // Release tracking
  release: 'adamftd-admin@' + process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'local', // 'development', 'production', 'staging'...
  debug: process.env.NODE_ENV === 'development', // Bật debug để kiểm tra log trong quá trình phát triển
});
